export const WHITEBOARD_ROLES = [
  'admin',
  'hr_manager',
  'it_manager',
  'tax_search_team_leader',
  'title_search_team_leader',
  'team_leader',
];

export const canUseWhiteboard = (role) => WHITEBOARD_ROLES.includes(role);
